<template>
  <span v-if="offset !== null && (offset < 362439)">{{ displayTime }}</span>
  <span v-else-if="offset !== null && (offset >= 362439)">99:99:99</span>
  <span v-else class="text-muted"></span>
</template>

<script>
  export default {
    name: 'Timer',
    props: [
      'initialOffset',
    ],

    data() {
      return {
        offset: null,
        displayTime: null,
        counterInterval: null,
      }
    },

    watch:{
      initialOffset(val) {
        if (!val) {
          this.offset = null
          this.displayTime = null
        }

        this.offset = val
      },
    },

    methods: {
      changeDisplayTime() {
        if (this.offset == null) return

        this.displayTime = this.formatTime(this.offset)
      },

      formatTime(seconds) {
        let h = parseInt(seconds / 60 / 60)
        let m = parseInt(seconds / 60 % 60)
        let s = parseInt(seconds % 60)

        return `${leadingZero(h)}:${leadingZero(m)}:${leadingZero(s)}`

        function leadingZero(num) {
          return num < 10 ? '0' + num : num
        }
      },

      step() {
        this.counterInterval = setTimeout(() => {
          this.offset++
          this.changeDisplayTime()
          this.step()
        }, 1000)
      },
    },

    created() {
      this.offset = this.initialOffset
    },

    mounted() {
      this.changeDisplayTime()

      this.step()
    },

    destroyed() {
      clearInterval(this.counterInterval)
      this.offset = null
      this.displayTime = null
      this.counterInterval = null
    },
  }
</script>
